import { values, keyBy, merge } from "lodash";
import store from "store";

/**
 * Get token item such as [URL_LOGO, Symbol, Logo ,...] item based on TMN or Tether market
 * @param value<String>
 * @returns Object which is corresponding to payload item
 */
export const getTokensItem = (value: string = "") => {
  const state = store.getState();
  const { bestPriceCoins, tokenStore } = state;
  const { allTokens } = tokenStore;
  const { allTetherMarket, allTomanMarket, tokenList } = bestPriceCoins;
  let newPairmarket: any = [];

  switch (value) {
    case "TMN":
      return tokensItem(allTomanMarket, newPairmarket, allTokens);
    case "USDT":
      return tokensItem(allTetherMarket, newPairmarket, allTokens);
    default:
      return tokensItem(tokenList, newPairmarket, allTokens);
  }
};

const tokensItem = (Tokes: any, newPairmarket: any, allTokens: any) => {
  if (Tokes.length) {
    Tokes.length &&
      Tokes.forEach((item: any, index: number) => {
        const [dummySymbol] = item.pair.split("/");
        newPairmarket = [...newPairmarket, { ...item, symbol: dummySymbol }];
      });
  }
  var result = values(
    merge(keyBy(newPairmarket, "symbol"), keyBy(allTokens, "symbol"))
  );
  return result;
};

export const nameTransformer = (symbol: string) => {
  switch (symbol) {
    case "sushi":
      return "sushiswap";
    case "chainlink":
      return "link";
    default:
      return symbol;
  }
};
export const getTokenInfo = (
  symbol: any,
  item: any = null,
  pair: any = "null",
  type: any = "symbol"
) => {
  const allTokens: any = getTokensItem(pair);  
  
  symbol = nameTransformer(symbol);
  if (allTokens.length) {
    const desiredTokenObject = allTokens.find((currentItem: any) => {
      return currentItem[type].toLowerCase() === symbol.toLowerCase();
    });

    return item ? desiredTokenObject[item] : desiredTokenObject;
  }
  return null;
};
